<template>
    <div class="modal fade inactivity queuedModal" tabindex="-1" :id="modalId" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content text-center">
                <div class="modal-body p-4">
                    <div v-html="message"></div>
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            modalId: {
                type: String,
                default: "queuedBookingAlertModal"
            },
        },
        data() {
            return {
                callback: () => {},
                message: ''
            }
        },
        methods: {
            show(message, callback) {
                if(message) {
                    this.message = message;
                }

                if(typeof callback == 'function') {
                    this.callback = callback;
                }

                $('#' + this.modalId).modal({
                    show: true,
                    backdrop: 'static',     
                    keyboard: false
                })
            },
            hide() {
                $('#' + this.modalId).modal('hide');
                if(typeof this.callback == 'function') {
                    this.callback();
                }
            }
        },
        mounted() {
            // const $this = this;
            // window.eventBus.$on($this.modalId, ({
            //     message, callback
            // }) => {
            //     if(typeof callback == 'function') {
            //         $this.callback = callback;
            //     }

            //     if(message) {
            //         $this.message = message;
            //     }

            //     $('.modal.queuedModal').modal('hide');
            //     $this.show();
            // });
        }
    }
</script>